import ConnectTemplateActivitiesToAreasModal from './connect-template-activities-to-areas-modal-container'
export default ConnectTemplateActivitiesToAreasModal
